import { render, staticRenderFns } from "./Mars.vue?vue&type=template&id=585b232c&scoped=true&"
import script from "./Mars.vue?vue&type=script&lang=js&"
export * from "./Mars.vue?vue&type=script&lang=js&"
import style0 from "./Mars.vue?vue&type=style&index=0&id=585b232c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b232c",
  null
  
)

export default component.exports